import React from 'react';
import { Container } from 'themes/MoGrid';
import CMSContext from 'context/CMSContext';
import helper from 'components/utils/helper';

const NoRoute = () => {
    const cms = React.useContext(CMSContext);
    const [error, setError] = React.useState();
    const [showMessage, setShowMessage] = React.useState(false);
    const path = window.location.pathname,
    message = `404: Page not found - ${path}`;

    React.useEffect(() => {
        // Check if a story page
        if(path.substr(0,7) === '/story/'){
          let url = helper.getLegacyAssetUrl('json', `resources/json/global${path}`);
            fetch(url)
            .then((res) => res.json())
            .then(
              result => {
                if(result){
                  addNewStoryToCms(result);
                }
              },
              error => {
                setShowMessage(true);
                setError(error.toString());
              }
            );
        } else {
          setShowMessage(true);
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function addNewStoryToCms(story){
        let newCms = {...cms}; // Must be new object otherwise MoRouter won't re-render
        // Set global story to current cms sitemap
        if(story.preRenderUrl && story.pages && story.components){
          newCms.preRenderUrl.push(story.preRenderUrl[0]);
          newCms.pages.stories.components.push(story.pages.stories.components[0]);
          newCms.components[story.pages.stories.components[0].id] = story.components[story.pages.stories.components[0].id];
          // Dispatch change cms event
          window.dispatchEvent(new CustomEvent('changeCms', { detail: {cms: newCms} }));
        }
    }
    return (
      <Container>
        {showMessage && <div>{message}</div>}
        {error && <div>{error}</div>}
      </Container>
    );
}
 
export default NoRoute;
